export default __webpack_public_path__ + "static/our-team@2x-8e4a9028c3868ddb974441981353a5b1.png";